import { NgModule }      from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsSwiper} from './swiper/component.swiper';
import {CasePracticeProNavComponent} from '../app/case-practice-pro-nav/case-practice-pro-nav.component';
import {ReportLevelExplainProComponent} from '../app/report-level-explain-pro/report-level-explain-pro.component';
import {ComponentsProAnimation} from './animation-pro/component-pro.animation';
import {componentMomentviewPro} from './momentviewpro/component.momentview-pro';
import {ComponentProApproach} from './approach-pro/component-pro.approach';
import {ComponentProButton} from './button-pro/component-pro.button';

@NgModule({
  imports:[ CommonModule ],
  declarations: [
    ReportLevelExplainProComponent,
    ComponentsProAnimation,
    CasePracticeProNavComponent,
    ComponentsSwiper,
    componentMomentviewPro,
    ComponentProApproach,
    ComponentProButton
  ],
  exports:      [
    ReportLevelExplainProComponent,
    ComponentsProAnimation,
    CasePracticeProNavComponent,
    ComponentsSwiper,
    componentMomentviewPro,
    ComponentProApproach,
    ComponentProButton
  ]
})
export class SharedProModule { }



// WEBPACK FOOTER //
// ./src/component/shareProModule.ts